// extracted by mini-css-extract-plugin
module.exports = {"Header":"LatestReviews_Header__2TDip","LoadMore":"LatestReviews_LoadMore__206mV"};